import { render, staticRenderFns } from "./MenuToday.vue?vue&type=template&id=5cfd9f98&"
import script from "./MenuToday.vue?vue&type=script&lang=js&"
export * from "./MenuToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports